import React, {useMemo} from 'react'
import TenableInfraMappingForm from './TenableInfraMappingForm';
import TenableInfraCredentialsForm from './TenableInfraCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function TenableInfraConfigListing(props) {

    const extraColumns = useMemo(() => (
        [
            {
                dataIndex: "assetName",
                title: "Scan Name (ID)",
                width: 150
            }
        ]
    ),[])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={TenableInfraMappingForm}
            triggerModifyParam={triggerModifyParam}
            CredentialsForm={TenableInfraCredentialsForm}
            displayComponentName="Scan Name "
            extraColumns={extraColumns}
        />
    )
}

const triggerModifyParam = (record) => {
    return {
        toolConfigId: record.id
    }
}